import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface TabHeaderProps {
  tabLabel: string;

  selected: boolean;
}
const TabHeader: FC<TabHeaderProps> = ({ tabLabel, selected }) => {
  return (
    <span
      className={twMerge(
        'block h-[44px] w-full whitespace-nowrap border-b border-b-ph-gray-evening px-6 py-3 text-sm font-bold text-ph-gray-evening',
        selected
          ? 'border-b-2 border-ph-primary-violet text-ph-primary-violet'
          : 'hover:border-ph-primary-violet hover:bg-gradient-to-t hover:from-[rgba(169,88,215,0.2)] hover:to-transparent hover:text-ph-primary-violet',
      )}
    >
      {tabLabel.toUpperCase()}
    </span>
  );
};

export default TabHeader;
